import { duration } from "@mui/material";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isSidebarOpen: false,
    modalState: {
        isOpen: false,
        Children: null,
        customStyle: {},
        isCenter: true,
        isCloseIcon: true,
        width: 414,
    },
    SnackbarState: {
        isOpen: false,
        message: '',
        duration: 5000,
        severity: 'info', // 'success', 'error', 'warning', 'info'
    }
}

const appSlice = createSlice({
    name: "app",
    initialState,
    reducers: {
        toggleSidebar: (state) => {
            state.isSidebarOpen = !state.isSidebarOpen;
        },
        openModal: (state, action) => {
            state.modalState = {
                ...state.modalState,
                ...action.payload,
                isOpen: true,
            };
        },
        closeModal: (state) => {
            state.modalState = {
                isOpen: false,
                Children: null,
                customStyle: {},
                isCenter: true,
                isCloseIcon: true,
                width: 414,
            };
        },
        showSnackbar: (state, action) => {
            state.SnackbarState = {
                ...state.SnackbarState,
                ...action.payload,
                isOpen: true,
            };
        },
        hideSnackbar: (state) => {
            state.SnackbarState = {
                isOpen: false,
                message: '',
                duration: 5000,
                severity: 'info', // 'success', 'error', 'warning', 'info'
            };
        },
    }
});

export const { toggleSidebar, openModal, closeModal, showSnackbar, hideSnackbar } = appSlice.actions;
export default appSlice.reducer;